import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/types';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[16/9] overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
            {article.tags[0]}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors mb-2">
          {article.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.readTime} 分钟
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {article.publishedAt}
            </span>
          </div>
          <span className="text-primary-600 flex items-center gap-1 whitespace-nowrap">
            阅读更多 <i className="ri-arrow-right-line text-xs"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}